import React from 'react';
import KakaoShareButton from './KakaoShareButton';
import WebShareButton from './WebShareButton';

const Share = ({ token, clientUuid , clientUsername}) => {

    const copyToClipboard = () => {
        const url = `http://localhost:5000/userSun/${clientUuid}`;
        navigator.clipboard.writeText(url)
            .then(() => {
                alert('URL이 클립보드에 복사되었습니다!');
            })
            .catch((err) => {
                console.error('클립보드 복사 실패:', err);
                alert('클립보드 복사에 실패했습니다.');
            });
    };

    // return (
    //     <div className="share-container">
    //         <h3 className="share-title">공유하기</h3>
    //         <div className="share-buttons">
    //             <KakaoShareButton clientUuid={clientUuid} />
    //             <WebShareButton clientUuid={clientUuid} />
    //             <button onClick={copyToClipboard} className="copy-button">
    //                 링크 복사
    //             </button>
    //         </div>
    //     </div>
    // );
    
    return (
        <div className="share-container">
          <h3 className="share-title">공유하기</h3>
          <div className="share-buttons">
            <KakaoShareButton clientUuid={clientUuid} clientUsername={clientUsername}/>
            <WebShareButton clientUuid={clientUuid} clientUsername={clientUsername} />
            <button onClick={copyToClipboard} className="share-button">
              <span className="emoji-button">🔗</span>
              <span className="button-text">링크 복사</span>
            </button>
          </div>
        </div>
      );
};

export default Share;